export default __webpack_public_path__ + "static/media/logo_full_gonemadstudios_white.d8c24916.png";